import { Alert, Drawer, Typography } from 'antd';
import type { Tenant } from 'breuer-supercharged-sdk';
import {
    useAdminFeedbackReviewCandidates,
    useAdminFeedbackReviewSettings,
    useUpdateAdminFeedbackReviewSettings,
} from '@/hooks/useSystemAdminApi';
import FeedbackReviewSettingsForm from '@/pages/feedback-review/feedback_review_settings_form';

const { Text } = Typography;

interface TenantFeedbackReviewDrawerProps {
    tenant: Tenant;
    open: boolean;
    onClose: () => void;
}

/** Prüfer-Ersteinrichtung eines Mandanten; remountet (neuer `key`) pro Öffnen, damit der Entwurf vom Serverstand startet. */
export default function TenantFeedbackReviewDrawer({ tenant, open, onClose }: TenantFeedbackReviewDrawerProps) {
    const settingsQuery = useAdminFeedbackReviewSettings(tenant.id);
    const candidatesQuery = useAdminFeedbackReviewCandidates(tenant.id);
    const update = useUpdateAdminFeedbackReviewSettings(tenant.id);

    return (
        <Drawer title={`Feedback-Prüfung – ${tenant.name}`} open={open} onClose={onClose} size="large">
            <Text type="secondary" style={{ display: 'block', marginBottom: 16 }}>
                Legen Sie fest, ob neues Feedback dieses Mandanten zuerst bei Prüfern landet und wer Prüfer ist.
            </Text>
            <FeedbackReviewSettingsForm
                settingsQuery={settingsQuery}
                candidatesQuery={candidatesQuery}
                isSaving={update.isPending}
                onSave={(dto) => update.mutateAsync(dto)}
                footerNote={
                    <Alert
                        type="info"
                        showIcon
                        title="Prüfer können die Liste danach selbst unter Verwaltung → Feedback-Prüfung pflegen."
                    />
                }
            />
        </Drawer>
    );
}
